// FINAL V1 CONTENT PACKAGE — implemented verbatim from the owner's content drop.
// This file is the single source of quiz content: future content edits happen
// here, never inside components.

export const EMOTIONAL_DECODER = {
    id: "emotional-reactions",
    slug: "emotional-reactions",
    title: "WHY THE FUCK DO I DO THAT?",
    resultIntro: "YOUR ANSWERS MOST CLOSELY RESEMBLE:",

    questions: [
        {
            id: "q1",
            scenario:
                "SOMEONE YOU CARE ABOUT SUDDENLY STARTS TEXTING DIFFERENTLY.\nShorter replies. Longer gaps. You can feel the vibe changed.",
            prompt: "WHAT'S YOUR FIRST MOVE?",
            options: [
                {
                    id: "q1a",
                    label: "I match their energy. If they're pulling back, so am I.",
                    scores: { DISTANCE: 2, MASK: 1 },
                },
                {
                    id: "q1b",
                    label:
                        "I'm rereading messages trying to figure out exactly when shit got weird.",
                    scores: { INVESTIGATE: 2, MASK: 1 },
                },
                {
                    id: "q1c",
                    label:
                        "I'm asking what's wrong. I'm not spending three days wondering.",
                    scores: { REPAIR: 2, INVESTIGATE: 1 },
                },
                {
                    id: "q1d",
                    label:
                        "I'm immediately irritated. If there's a problem, fucking say it.",
                    scores: { DEFEND: 2, REPAIR: 1 },
                },
            ],
        },
        {
            id: "q2",
            scenario: "YOU'RE UPSET WITH SOMEONE YOU LOVE.\nTHEN THEY ASK:",
            prompt: "“WHAT'S WRONG?”",
            options: [
                {
                    id: "q2a",
                    label:
                        "“Nothing.”\nThey should already know something's off.",
                    scores: { MASK: 2, INVESTIGATE: 1 },
                },
                {
                    id: "q2b",
                    label:
                        "I tell them.\nWe're dealing with this now because I can't stand weird tension.",
                    scores: { REPAIR: 2, DEFEND: 1 },
                },
                {
                    id: "q2c",
                    label:
                        "I need space before I talk.\nI don't trust what'll come out yet.",
                    scores: { DISTANCE: 2, DEFEND: 1 },
                },
                {
                    id: "q2d",
                    label:
                        "Somehow I end up worrying about how THEY'RE feeling and making everything easier for them.",
                    scores: { OVERFUNCTION: 2, MASK: 1 },
                },
            ],
        },
        {
            id: "q3",
            scenario:
                "SOMEONE DISAPPOINTS YOU AFTER YOU WERE REALLY COUNTING ON THEM.",
            prompt: "WHAT HAPPENS NEXT?",
            options: [
                {
                    id: "q3a",
                    label:
                        "Fine. I'll handle it myself.\nI probably should've done that anyway.",
                    scores: { OVERFUNCTION: 2, DISTANCE: 1 },
                },
                {
                    id: "q3b",
                    label:
                        "I need to understand WHY.\nWhat happened? What changed? What am I missing?",
                    scores: { INVESTIGATE: 2, REPAIR: 1 },
                },
                {
                    id: "q3c",
                    label:
                        "I tell them exactly why I'm pissed.\nThey're not getting a vague little “it's okay.”",
                    scores: { DEFEND: 2, REPAIR: 1 },
                },
                {
                    id: "q3d",
                    label:
                        "“No worries!”\nMeanwhile, there are definitely fucking worries.",
                    scores: { MASK: 2, DISTANCE: 1 },
                },
            ],
        },
        {
            id: "q4",
            scenario:
                "YOU REALIZE YOU NEED MORE FROM SOMEONE THAN YOU'RE CURRENTLY GETTING.",
            prompt: "WHAT DO YOU DO?",
            options: [
                {
                    id: "q4a",
                    label:
                        "I ask for it.\nI'd rather know where we stand than keep guessing.",
                    scores: { REPAIR: 2, INVESTIGATE: 1 },
                },
                {
                    id: "q4b",
                    label:
                        "I start questioning whether I'm asking for too much in the first place.",
                    scores: { MASK: 2, OVERFUNCTION: 1 },
                },
                {
                    id: "q4c",
                    label:
                        "I stop needing it from them.\nOr at least convince myself I don't.",
                    scores: { DISTANCE: 2, MASK: 1 },
                },
                {
                    id: "q4d",
                    label:
                        "I start doing more for the relationship and hope they naturally meet me there.",
                    scores: { OVERFUNCTION: 2, REPAIR: 1 },
                },
            ],
        },
        {
            id: "q5",
            scenario:
                "THINGS FEEL WEIRD BETWEEN YOU AND SOMEONE YOU LOVE.\nYOU DON'T ACTUALLY KNOW WHY.",
            prompt: "WHAT'S YOUR INSTINCT?",
            options: [
                {
                    id: "q5a",
                    label:
                        "I start connecting dots.\nTone. Timing. Conversations. Little changes.\nThere's gotta be a reason.",
                    scores: { INVESTIGATE: 2, MASK: 1 },
                },
                {
                    id: "q5b",
                    label:
                        "I'm irritated.\nIf something's wrong, I'd rather they just fucking say it.",
                    scores: { DEFEND: 2, DISTANCE: 1 },
                },
                {
                    id: "q5c",
                    label:
                        "I'm probably trying harder.\nChecking in. Helping. Being extra thoughtful. Keeping things good.",
                    scores: { OVERFUNCTION: 2, REPAIR: 1 },
                },
                {
                    id: "q5d",
                    label:
                        "I keep acting normal.\nThey don't need to know how much I'm thinking about it.",
                    scores: { MASK: 2, INVESTIGATE: 1 },
                },
            ],
        },
    ],

    tieBreak: {
        header: "ONE MORE.",
        headerAccent: "YOU'RE MAKING THIS DIFFICULT. 👀",
        subtext:
            "Which one feels MORE like you when something important feels uncertain?",
        statements: {
            DISTANCE: "I start preparing to need them less.",
            INVESTIGATE: "I start trying to figure out what's really going on.",
            REPAIR: "I need us to talk about it so I know where we stand.",
            DEFEND: "I get irritated before I let anyone see that I'm hurt.",
            MASK: "I stay engaged, but I hide how much it's affecting me.",
            OVERFUNCTION:
                "I start doing more to make the connection feel secure.",
        },
    },

    patterns: [
        {
            key: "DISTANCE",
            slug: "distance",
            title: "PULL AWAY FIRST",
            recognition:
                "When something starts feeling uncertain, you don't always move closer to find out why.\nSometimes you start preparing to need them less.\nYou might answer less.\nStop initiating.\nBecome suddenly very independent.\nStart mentally preparing for what happens if this person isn't there anymore.\nNot necessarily because you stopped caring.\nSometimes it's because caring while someone else controls the distance feels worse.",
            underneath:
                "Pulling away can turn uncertainty into something you control.\nIf YOU create the distance, you don't have to sit there wondering whether someone else is about to.\nThere can be a strange safety in needing less.",
            reveal:
                "Sometimes independence isn't about needing nobody.\nIt's about making sure nobody else gets to decide when you lose them.",
            shareQuote:
                "“I DON'T CHASE PEOPLE.\nI JUST START PRACTICING LIFE WITHOUT THEM.”",
            chartAreas: [
                {
                    name: "MOON",
                    blurb:
                        "What helps you feel emotionally safe and what happens when that safety feels uncertain.",
                },
                {
                    name: "SATURN",
                    blurb:
                        "Where self-protection, boundaries, fear, responsibility, or hyper-independence can become especially loud.",
                },
                {
                    name: "MARS",
                    blurb:
                        "Your instinctive response when something feels threatening, frustrating, or vulnerable.",
                },
            ],
        },
        {
            key: "INVESTIGATE",
            slug: "investigate",
            title: "FIGURE IT OUT BEFORE YOU ASK",
            recognition:
                "You notice things.\nThe shorter message.\nDifferent punctuation.\nThe weird pause.\nSomething they said three days ago that suddenly seems relevant.\nAnd suddenly your brain has opened a fucking investigation.",
            underneath:
                "Information can create a sense of control when uncertainty feels uncomfortable.\nBecause asking directly requires something analysis doesn't:\nletting another person give you an answer you can't control.\nSometimes you'd rather investigate the silence than risk asking a question whose answer might hurt.",
            reveal:
                "Sometimes you're not looking for information.\nYou're looking for enough certainty to feel safe asking the question.",
            shareQuote:
                "“I'VE ALREADY INVESTIGATED THE SITUATION.\nI JUST HAVEN'T ASKED THE PERSON INVOLVED.”",
            chartAreas: [
                {
                    name: "MERCURY",
                    blurb:
                        "How you process information, ambiguity, uncertainty, and communication.",
                },
                {
                    name: "MOON",
                    blurb:
                        "What happens internally when emotional security feels uncertain.",
                },
                {
                    name: "PLUTO",
                    blurb:
                        "Themes involving trust, intensity, vulnerability, power, and what feels psychologically loaded.",
                },
            ],
        },
        {
            key: "REPAIR",
            slug: "repair",
            title: "FIX IT RIGHT FUCKING NOW",
            recognition:
                "Something feels wrong and you want it addressed.\nTalk about it.\nExplain it.\nFix it.\nNOW.\nYou'd often rather have the uncomfortable conversation than spend the next two days wondering what the hell is happening.",
            underneath:
                "Wanting direct communication isn't inherently unhealthy.\nBut sometimes there's another layer:\nResolution regulates you.\nOnce you know where you stand, your system can stop preparing for every possible answer.",
            reveal:
                "Sometimes you're not rushing the conversation because you love conflict.\nYou're rushing toward certainty because uncertainty feels worse.",
            shareQuote:
                "“I CAN HANDLE A HARD CONVERSATION.\nIT'S THE NOT KNOWING THAT'S FUCKING ME UP.”",
            chartAreas: [
                {
                    name: "MOON",
                    blurb:
                        "Emotional security, reassurance, and what helps you feel safe in connection.",
                },
                {
                    name: "MERCURY",
                    blurb:
                        "How you communicate when something needs to be understood or clarified.",
                },
                {
                    name: "MARS",
                    blurb:
                        "How quickly you move toward confrontation, action, or resolution.",
                },
            ],
        },
        {
            key: "DEFEND",
            slug: "defend",
            title: "GET MAD BEFORE YOU GET HURT",
            recognition:
                "Something lands wrong.\nBut before anybody gets access to disappointment, embarrassment, rejection, or hurt...\nanger gets there first.\nMaybe you're sharp.\nIrritated.\nDefensive.\nConfrontational.\nThe anger can be completely real.\nIt just might not be the first feeling that happened.",
            underneath:
                "Anger creates movement and power.\nHurt can feel considerably more exposed.\nSometimes anger gets to the conversation before the hurt does because anger feels easier to stand inside.",
            reveal:
                "The anger may be real.\nIt just might be protecting a feeling that arrived first.",
            shareQuote:
                "“MY ANGER SHOWED UP TO DEFEND\nA FEELING I HADN'T EVEN ADMITTED YET.”",
            chartAreas: [
                {
                    name: "MARS",
                    blurb: "Anger, assertion, conflict, and instinctive reactions.",
                },
                {
                    name: "MOON",
                    blurb:
                        "Emotional vulnerability, security, and what hurts when an important need isn't met.",
                },
                {
                    name: "PLUTO",
                    blurb:
                        "Intensity, trust, exposure, control, and emotional power.",
                },
            ],
        },
        {
            key: "MASK",
            slug: "mask",
            title: "ACT LIKE YOU'RE FINE",
            recognition:
                "You stay.\nYou respond.\nYou might even behave completely normally.\nBut somebody could be standing three feet away from you and have absolutely no fucking idea how deeply something affected you.\nYou don't necessarily leave.\nYou hide the impact.",
            underneath:
                "Showing someone that they affected you means giving them information about what matters to you.\nAnd sometimes THAT feels more vulnerable than the feeling itself.\nEspecially when part of you wonders:\nWhat happens if I tell them what I need...\nand nothing changes?",
            reveal:
                "Sometimes “I'm fine” doesn't mean you don't need anything.\nIt means needing something feels safer when nobody can see it.",
            shareQuote:
                "“I'M NOT UNBOTHERED.\nI'M JUST NOT LETTING YOU WATCH ME BE BOTHERED.”",
            chartAreas: [
                {
                    name: "MOON",
                    blurb: "Emotional needs, security, and vulnerability.",
                },
                {
                    name: "SATURN",
                    blurb:
                        "Restraint, self-protection, and places where expressing need may feel difficult.",
                },
                {
                    name: "MERCURY",
                    blurb:
                        "How easily your internal experience becomes spoken communication.",
                },
            ],
        },
        {
            key: "OVERFUNCTION",
            slug: "overfunction",
            title: "DO MORE SO NOTHING FALLS APART",
            recognition:
                "When connection feels uncertain, you don't necessarily demand more from the other person.\nSometimes YOU become more.\nMore helpful.\nMore available.\nMore accommodating.\nMore thoughtful.\nMaybe you fix the problem.\nHandle the details.\nMake their life easier.\nKeep everything running.\nBecause doing something can feel better than waiting to find out whether everything is okay.",
            underneath:
                "Being useful can create a powerful sense of security.\nIf you're valuable enough...\nhelpful enough...\nneeded enough...\nmaybe your place feels safer.",
            reveal:
                "Being needed can feel safer than trusting you're wanted.",
            shareQuote:
                "“I KEEP TRYING TO EARN A PLACE\nI WISH I COULD JUST TRUST I HAVE.”",
            chartAreas: [
                {
                    name: "VENUS",
                    blurb:
                        "How you give and receive love, connection, affection, and value.",
                },
                {
                    name: "MOON",
                    blurb:
                        "What creates emotional security and what happens when connection feels uncertain.",
                },
                {
                    name: "SATURN",
                    blurb:
                        "Responsibility, worthiness, and places where love or belonging may begin feeling like something that has to be earned.",
                },
            ],
        },
    ],
};
